import { useTheme } from '@mui/material'

interface IProps {
  className?: string
  color?: string
}

const KeyIcon = ({ className, color }: IProps) => {
  const theme = useTheme()

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill={color || theme.palette.custom.darkBlue2}
    >
      <path
        fill="inherit"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7C6 3.13401 9.13401 0 13 0C16.866 0 20 3.13401 20 7C20 10.866 16.866 14 13 14H11V16H9V18H7V20H0V14.5858L6.14801 8.43778C6.04995 7.96847 6 7.48731 6 7ZM9 14V12H13C15.7614 12 18 9.76142 18 7C18 4.23858 15.7614 2 13 2C10.2386 2 8 4.23858 8 7C8 7.49863 8.07269 7.98638 8.21408 8.45287L8.38789 9.02633L2 15.4142V18H5V16H7V14H9ZM11 7C11 8.10457 11.8954 9 13 9C14.1046 9 15 8.10457 15 7C15 5.89543 14.1046 5 13 5C11.8954 5 11 5.89543 11 7Z"
      />
    </svg>
  )
}

export { KeyIcon }
